import { render, staticRenderFns } from "./FormVerifikasi.vue?vue&type=template&id=4c4c6f60&"
import script from "./FormVerifikasi.vue?vue&type=script&lang=js&"
export * from "./FormVerifikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports